import { render, staticRenderFns } from "./GallerySelector.vue?vue&type=template&id=462bbfaa&scoped=true"
import script from "./GallerySelector.vue?vue&type=script&lang=js"
export * from "./GallerySelector.vue?vue&type=script&lang=js"
import style0 from "./GallerySelector.vue?vue&type=style&index=0&id=462bbfaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462bbfaa",
  null
  
)

export default component.exports